import { render, staticRenderFns } from "./PoweredByContainer.vue?vue&type=template&id=23cf5180&scoped=true"
import script from "./PoweredByContainer.vue?vue&type=script&lang=js"
export * from "./PoweredByContainer.vue?vue&type=script&lang=js"
import style0 from "./PoweredByContainer.vue?vue&type=style&index=0&id=23cf5180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf5180",
  null
  
)

export default component.exports